import type { ReactNode } from 'react';

export function PreviewStatus({ children }: { children: ReactNode }) {
  return (
    <div className="text-muted-foreground flex h-full min-h-48 items-center justify-center p-6 text-sm">{children}</div>
  );
}

export function PreviewError({ message }: { message: string }) {
  return (
    <PreviewStatus>
      <div className="max-w-md text-center">
        <div className="text-primary font-medium">Preview failed to load.</div>
        <div className="mt-1 break-words">{message}</div>
      </div>
    </PreviewStatus>
  );
}
